"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return SelectOption;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
let SelectOption = class SelectOption {
    static async insert(context, data, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(data, [
            'id',
            'title',
            'fk_column_id',
            'color',
            'order'
        ]);
        const column = await _models.Column.get(context, {
            colId: insertObj.fk_column_id
        }, ncMeta);
        if (!column) {
            _catchError.NcError.fieldNotFound(insertObj.fk_column_id);
        }
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.COL_SELECT_OPTIONS, insertObj);
        return this.get(context, id, ncMeta).then(async (selectOption)=>{
            await _NocoCache.default.appendToList(context, _globals.CacheScope.COL_SELECT_OPTION, [
                data.fk_column_id
            ], `${_globals.CacheScope.COL_SELECT_OPTION}:${id}`);
            return selectOption;
        });
    }
    static async bulkInsert(context, data, ncMeta = _Noco.default.ncMeta) {
        const insertObj = [];
        for (const d of data){
            const tempObj = (0, _extractProps.extractProps)(d, [
                'id',
                'title',
                'fk_column_id',
                'color',
                'order'
            ]);
            insertObj.push(tempObj);
        }
        if (!insertObj.length) {
            return false;
        }
        const bulkData = await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.COL_SELECT_OPTIONS, insertObj);
        for (const d of bulkData){
            await _NocoCache.default.set(context, `${_globals.CacheScope.COL_SELECT_OPTION}:${d.id}`, d);
            await _NocoCache.default.appendToList(context, _globals.CacheScope.COL_SELECT_OPTION, [
                d.fk_column_id
            ], `${_globals.CacheScope.COL_SELECT_OPTION}:${d.id}`);
        }
        return true;
    }
    static async get(context, selectOptionId, ncMeta = _Noco.default.ncMeta) {
        let data = selectOptionId && await _NocoCache.default.get(context, `${_globals.CacheScope.COL_SELECT_OPTION}:${selectOptionId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!data) {
            data = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COL_SELECT_OPTIONS, selectOptionId);
            await _NocoCache.default.set(context, `${_globals.CacheScope.COL_SELECT_OPTION}:${selectOptionId}`, data);
        }
        return data && new SelectOption(data);
    }
    static async read(context, fk_column_id, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.COL_SELECT_OPTION, [
            fk_column_id
        ]);
        let { list: options } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !options.length) {
            options = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_SELECT_OPTIONS, {
                condition: {
                    fk_column_id
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.COL_SELECT_OPTION, [
                fk_column_id
            ], options.map((_0)=>{
                let { created_at, updated_at } = _0, others = _object_without_properties_loose(_0, [
                    "created_at",
                    "updated_at"
                ]);
                return others;
            }));
        }
        return (options == null ? void 0 : options.length) ? {
            options: options.map((_0)=>{
                let { created_at, updated_at } = _0, c = _object_without_properties_loose(_0, [
                    "created_at",
                    "updated_at"
                ]);
                return new SelectOption(c);
            }).sort((x, y)=>x.order - y.order)
        } : {
            options: []
        };
    }
    static async find(context, fk_column_id, title, ncMeta = _Noco.default.ncMeta) {
        const data = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COL_SELECT_OPTIONS, {
            fk_column_id,
            title
        });
        return data && new SelectOption(data);
    }
    constructor(data){
        Object.assign(this, data);
    }
};
